module.exports = "<div class=dt-thing-details__subheader>Advanced</div> <ul class=\"custom-list custom-list--simple custom-list--striped\"> <li layout=row layout-align=\"start start\"> <div layout=column layout-align=\"start start\" flex> <div class=md-body-1><b>Firmware</b></div> </div> <div layout=column layout-align=\"start start\" flex> <div class=md-body-1>{{ $ctrl.advancedInformation.firmware.version }}</div> </div> </li> </ul>";


//////////////////
// WEBPACK FOOTER
// ./app/components/sensors-and-connectors/components/thing-details/advanced-information/advanced-information.html
// module id = +jTT
// module chunks = 1